var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:({width: _vm.size + 'px'}),attrs:{"src":"/img/progress-circle.svg","alt":"Loader"}})}
var staticRenderFns = []

export { render, staticRenderFns }